import { DateTime } from "luxon";

/**
 * Pause end date in the given locale ("15 Aug 2026, 18:00"), or null when the
 * pause is indefinite. `pausedUntil` arrives from the API as an ISO string, so it
 * is zoned explicitly with the salon timezone instead of relying on Luxon's
 * global default zone.
 */
export function formatPauseEnd(
  isIndefinite: boolean,
  pausedUntil: string | null,
  salonTimezone: string,
  locale: string
): string | null {
  if (isIndefinite || !pausedUntil) return null;

  const until = DateTime.fromISO(pausedUntil, { zone: salonTimezone });
  if (!until.isValid) return null;

  return until.setLocale(locale).toLocaleString(DateTime.DATETIME_MED);
}
